import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Label } from '../../ui/label';

export const MeetingField = ({ label, name, value, onChange, multiline = false, type = 'text', maxLength = 300, required = false }) => {
  const Component = multiline ? Textarea : Input;
  return <div className="min-w-0 space-y-1.5">
    <Label htmlFor={`meeting-${name}`}>{label}{required ? ' *' : ''}</Label>
    <Component id={`meeting-${name}`} data-testid={`meeting-${name}`} value={value || ''} onChange={e => onChange(e.target.value)}
      {...(multiline ? { rows: 5 } : { type })} maxLength={maxLength} required={required}
      className={`w-full min-w-0 ${multiline ? 'resize-y leading-relaxed' : ''}`} />
  </div>;
};

export const MeetingSection = ({ title, name, children }) => <section className="border-b border-teal-100 py-7 last:border-b-0" data-testid={`meeting-section-${name}`}>
  <h2 className="mb-5 text-base font-bold text-teal-800 md:text-lg">{title}</h2>
  {children}
</section>;

export const MeetingDetails = ({ form, setField }) => <>
  <MeetingSection title="Meeting details" name="details">
    <div className="grid min-w-0 gap-5 sm:grid-cols-2">
      <div className="sm:col-span-2"><MeetingField label="Meeting title" name="title" value={form.title} onChange={v => setField('title', v)} maxLength={160} required /></div>
      <MeetingField label="Meeting date" name="date" type="date" value={form.meeting_date} onChange={v => setField('meeting_date', v)} />
      <MeetingField label="Meeting time" name="time" type="time" value={form.meeting_time} onChange={v => setField('meeting_time', v)} />
      <div className="sm:col-span-2"><MeetingField label="Location or meeting link" name="location" value={form.location} onChange={v => setField('location', v)} maxLength={2000} /></div>
    </div>
  </MeetingSection>
</>;

export const NextMeetingFields = ({ form, setField }) => <MeetingSection title="Next meeting" name="next">
  <div className="grid min-w-0 gap-5 sm:grid-cols-2">
    <MeetingField label="Next meeting date" name="next-date" type="date" value={form.next_meeting_date} onChange={v => setField('next_meeting_date', v)} />
    <MeetingField label="Next meeting time" name="next-time" type="time" value={form.next_meeting_time} onChange={v => setField('next_meeting_time', v)} />
    <div className="sm:col-span-2"><MeetingField label="Next location or meeting link" name="next-location" value={form.next_meeting_location} onChange={v => setField('next_meeting_location', v)} maxLength={2000} /></div>
    <div className="sm:col-span-2"><MeetingField label="Next meeting agenda / notes" name="next-notes" multiline value={form.next_meeting_notes} onChange={v => setField('next_meeting_notes', v)} maxLength={20000} /></div>
  </div>
</MeetingSection>;